// 3rd Party
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { Div, FlexRow, H3, H4, H5 } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

import { PROFILE_ACHIEVEMENT_TYPES } from '../../constants/constants';
import AssociationSvg from '../svgs/AssociationSvg';
import AwardSvg from '../svgs/AwardSvg';
import CertificationSvg from '../svgs/CertificationSvg';
import EducationSvg from '../svgs/EducationSvg';

import { Body, Info, InfoCardSectionHeader } from './styled-components';

// Other

const formatDate = date =>
  moment(date, 'YYYY-MM-DD')
    .utc()
    .format('MMM D, YYYY');

const getSvgByType = type => {
  switch (type) {
    case PROFILE_ACHIEVEMENT_TYPES.association:
      return <AssociationSvg color={colors.blue} height="40px" width="48px" />;
    case PROFILE_ACHIEVEMENT_TYPES.awards:
      return <AwardSvg color={colors.blue} height="40px" width="48px" />;
    case PROFILE_ACHIEVEMENT_TYPES.certification:
      return (
        <CertificationSvg color={colors.blue} height="40px" width="48px" />
      );
    case PROFILE_ACHIEVEMENT_TYPES.education:
      return <EducationSvg color={colors.blue} height="40px" width="48px" />;
    default:
      return;  
  }
};

// Component
const AchievementsInfo = ({ achievements, hideTitle, title }) =>
  achievements
  && achievements.length !== 0 
  && (
    <Div margin="20px 0">
      {!hideTitle 
        && <InfoCardSectionHeader fontWeight="300">{title}</InfoCardSectionHeader>
      }
      <FlexRow flexWrap="wrap" margin="0 5px" padding="0" as="ul">
        {achievements.map(item => (
          <Info
            key={item.name || item.degree + item.institution}
            margin="10px 0"
            as="li"
          >
            <Div margin="0 0 0 10px">{getSvgByType(item.type)}</Div>
            <Body margin="0 10px">
              {item.type && item.type !== 'AWARDS' 
                && (
                  <H5 color={colors.blue} fontSize="12px">
                    {item.type}
                  </H5>
                )
              }
              <H3 fontWeight="300" fontSize="18px" margin="4px 0">
                {item.name || item.degree}
              </H3>
              {item.institution 
                && (
                  <H4 color={colors.slate} fontSize="14px">
                    {item.institution}
                  </H4>
                )
              }
              {item.date 
                && (
                  <H4 color={colors.slate} fontSize="14px">
                    {formatDate(item.date)}
                  </H4>
                )
              }
            </Body>
          </Info>
        ))}
      </FlexRow>
    </Div>
  )
  ;

AchievementsInfo.propTypes = {
  achievements: PropTypes.array,
  hideTitle: PropTypes.bool,
  title: PropTypes.string,
};

export default AchievementsInfo;
